import { FC } from 'react';

type Props = {
	className?: string;
};

const ArrowExpandIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M6.88889 3.07606C6.88889 3.07606 3.80402 2.79929 3.30165 3.30166C2.79926 3.80403 3.07609 6.8889 3.07609 6.8889'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M6.88889 16.9242C6.88889 16.9242 3.80402 17.201 3.30165 16.6986C2.79926 16.1962 3.07609 13.1113 3.07609 13.1113'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M13.1094 3.07606C13.1094 3.07606 16.1943 2.79929 16.6966 3.30166C17.199 3.80403 16.9222 6.8889 16.9222 6.8889'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M13.1094 16.9242C13.1094 16.9242 16.1943 17.201 16.6966 16.6986C17.199 16.1962 16.9222 13.1113 16.9222 13.1113'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M11.5625 8.4432L16.2694 3.73633'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M8.44066 11.5571L3.49609 16.518'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M8.44085 8.44626L3.65625 3.66797'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M11.5391 11.5571L16.6323 16.6095'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ArrowExpandIcon;
